// extracted by mini-css-extract-plugin
module.exports = {"container":"LightboxImage__container__4-PcU","lightboxImage":"LightboxImage__lightboxImage__V+Sqr","closeButton":"LightboxImage__closeButton__MznGU"};